import { UserMinus } from "lucide-react";
import { toast } from "sonner";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "./ui/alert-dialog";
import { api, errMsg } from "../lib/api";

export const RemoveMemberButton = ({ tid, row, onRemoved }) => {
  const remove = async () => {
    try {
      await api.delete(`/tournaments/${tid}/members/${row.user_id}`);
      toast.success(`${row.name} rimosso dal torneo`);
      onRemoved?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button className="text-slate-400 hover:text-red-400 ml-3" title="Rimuovi giocatore" data-testid={`remove-member-button-${row.user_id}`}>
          <UserMinus size={16} />
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-[#121824] border-[#26334D]">
        <AlertDialogHeader>
          <AlertDialogTitle>Rimuovere {row.name}?</AlertDialogTitle>
          <AlertDialogDescription>Il giocatore esce dal torneo e i suoi pronostici vengono cancellati.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="remove-member-cancel">Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={remove} className="bg-red-500 hover:bg-red-600" data-testid="remove-member-confirm">Rimuovi</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
